var $8eb872c6e0dc69c6$exports = {};
$8eb872c6e0dc69c6$exports = {
    "breadcrumbs": `S\xf6kv\xe4gar`
};


export {$8eb872c6e0dc69c6$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
